import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextUnderline = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.1673 16.6673H5.83398M14.1673 3.33398V8.88954C14.1673 11.1907 12.3018 13.0562 10.0007 13.0562C7.69946 13.0562 5.83398 11.1907 5.83398 8.88954V3.33398",
		stroke: "#71717A",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgTextUnderline);
export default ForwardRef;
